import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"cat"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M12 22C17.5228 22 22 17.6658 22 12.3193V2L16.4444 3.64493C15.1056 3.00083 13.5965 2.63866 12 2.63866C10.4035 2.63866 8.8944 3.00083 7.55556 3.64493L2 2V12.3193C2 17.6658 6.47715 22 12 22Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M22 11.7143V2L17.1389 3.43931M2 11.7143V2L6.86111 3.43931M22 12.3193C22 17.6658 17.5228 22 12 22C6.47715 22 2 17.6658 2 12.3193C2 6.97284 6.47715 2.63866 12 2.63866C17.5228 2.63866 22 6.97284 22 12.3193Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M8 10V11M16 10V11M8 15C9 16.5 11 16.5 12 14.5C13 16.5 15 16.5 16 15","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Cat = Vue.extend<IconProps>({
  name: 'CatIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'cat',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Cat;
